<template>
    <h2
        :class="[
            props.ColourScheme,
            props.FontSize,
            props.FontFamily,
            props.FontWeight,
            props.FontStyle,
            props.TextDecoration,
        ]">
        <slot />
    </h2>
</template>

<script setup lang="ts">
    import {
        ColourScheme as ColourSchemeEnum,
        FontSize as FontSizeEnum,
        FontFamily as FontFamilyEnum,
        FontWeight as FontWeightEnum,
        TextDecoration as TextDecorationEnum,
        FontStyle as FontStyleEnum,
    } from '@/enums/Typography';
    import { TitleTypes } from '@/components/ComponentTypes';

    const props = withDefaults(defineProps<TitleTypes>(), {
        ColourScheme: ColourSchemeEnum.theme,
        FontSize: FontSizeEnum.standard,
        FontFamily: FontFamilyEnum.body,
        FontWeight: FontWeightEnum.standard,
        FontStyle: FontStyleEnum.none,
        TextDecoration: TextDecorationEnum.none,
    });
</script>
